import { defineMessages } from 'react-intl';

export default defineMessages({
  delivery: {
    id: 'app.shopDetails.components.Pickup.Toggle.delivery',
    defaultMessage: 'Delivery',
  },
  pickup: {
    id: 'app.shopDetails.components.Pickup.Toggle.pickup',
    defaultMessage: 'Retiro en local',
  },
});
